import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { formInputTheme } from "../../textinput/styled/formInputTheme";
import { checkboxLabelTheme } from "../checkboxTheme";
var getLabelColor = function getLabelColor(_ref) {
  var isDisabled = _ref.isDisabled,
    themeMode = _ref.themeMode;
  return isDisabled ? checkboxLabelTheme.color.disabled(themeMode) : checkboxLabelTheme.color.rest(themeMode);
};
export var LabelText = styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    // We want the first line of text to line up with the checkbox so we cannot use flex to center.\n    // In a multi-line label, the checkbox would be centered in the middle line of text, rather than\n    // the first.\n    margin-top: 1px;\n    margin-left: ", ";\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n"])), function (_ref2) {
  var themeMode = _ref2.themeMode;
  return checkboxLabelTheme.gap(themeMode);
}, getLabelColor, function (_ref3) {
  var themeMode = _ref3.themeMode;
  return checkboxLabelTheme.fontWeight(themeMode);
}, function (_ref4) {
  var themeMode = _ref4.themeMode;
  return formInputTheme.fontSize.box(themeMode);
});
//# sourceMappingURL=LabelText.js.map